import { Theme } from "app/umbraco/models/settings.model";
import { CSSProperties } from "react";

export default (theme?: Theme, variant?: string): object => {
    const result: CSSProperties = {};

    try {
        let styles: any = undefined;

        // 1/2  - Variant selection

        if (variant && variant.toUpperCase() === "SECONDARY" && theme?.secondaryButton?.[0]?.content?.["_contentType"]) {
            styles = theme?.secondaryButton?.[0];
        }
        else if (variant && variant.toUpperCase() === "TERTIARY" && theme?.tertiaryButton?.[0]?.content?.["_contentType"]) {
            styles = theme?.tertiaryButton?.[0];
        }
        else if (variant && variant.toUpperCase() === "ARROW" && theme?.arrowButton?.[0]?.content?.["_contentType"]) {
            styles = theme?.arrowButton?.[0];
        }
        else {
            styles = theme?.primaryButton?.[0];
        }

        // 2/2  - Result output

        if (styles?.content.backgroundColor) {
            result["--button-background-color"] = styles?.content.backgroundColor;
        }

        if (styles?.content.textColor) {
            result["--button-text-color"] = styles?.content.textColor;
        }

        if (styles?.content.hoverBackgroundColor) {
            result["--button-hover-background-color"] = styles?.content.hoverBackgroundColor;
        }

        if (styles?.content.hoverTextColor) {
            result["--button-hover-text-color"] = styles?.content.hoverTextColor;
        }

        if (styles?.content.borderWidth) {
            result["--button-border-width"] = styles?.content.borderWidth + "px";
        }

        if (styles?.content.borderWidth) {
            result["--button-border-color"] = styles?.content.borderColor;
        }
    }
    catch {
        // TODO
    }

    return result;
};